module.exports = __webpack_public_path__ + "img/Adel.59c2c61.png";